import { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SUPPORTED } from '../i18n/index.js';
import { useConfig } from '../store/configStore.js';
import { Icon } from './Icon.jsx';
import { Flag } from './Flag.jsx';

export function LanguageSwitcher() {
  const lang = useConfig((s) => s.config.settings.language);
  const setPath = useConfig((s) => s.setPath);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (!ref.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const cur = SUPPORTED.find((l) => l.code === lang) || SUPPORTED[0];

  return (
    <div className="lang" ref={ref}>
      <button className="btn sm" onClick={() => setOpen((v) => !v)} title={cur.label}>
        <Flag code={cur.flagCode} size={20} />
        <span className="lang-code">{cur.code.toUpperCase()}</span>
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            className="lang-menu"
            initial={{ opacity: 0, y: -4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -4 }}
            transition={{ duration: 0.14 }}
          >
            {SUPPORTED.map((l) => (
              <button
                key={l.code}
                className={`lang-item ${l.code === lang ? 'active' : ''}`}
                onClick={() => {
                  setPath('settings.language', l.code);
                  setOpen(false);
                }}
              >
                <Flag code={l.flagCode} size={22} />
                <span className="lang-label">{l.label}</span>
                {l.code === lang && <Icon name="check" size={14} />}
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
